/**
 * ReservationPersons
 * ======================================
 */

const BTN = '#js-ReservationPersonsBtn'
const BTN_REMOVE = '#js-ReservationPersonsBtnRemove'
const INPUT = '#js-ReservationTermInput'

class ReservationPersons {
  constructor() {
    this.people = document.querySelector('#form__people')
    this.people_list = document.querySelector('#form__people-list')
    this.people_row = document.querySelector('.form__people-row')
    this.btn = document.querySelector(BTN)
    this.btn_remove = document.querySelector(BTN_REMOVE)
    this.input = document.querySelector(INPUT)

    if(!this.btn){
      return
    }

    this.btn.addEventListener('click', this.clickHandler, false)
    this.btn_remove.addEventListener('click', this.clickRemoveHandler, false)
  }

  changeHandler = () => {
    const value = parseInt(this.input.value)
    const inputs = this.people_list.querySelectorAll('input')

    if(value > 1){
      this.people.style.display = 'block'

      inputs.forEach(el => {
        el.setAttribute('required', 'required')
      })
    } else {
      this.people.style.display = 'none'

      inputs.forEach(el => {
        el.removeAttribute('required')
      })
    }
  }

  clickRemoveHandler = () => {
    const lastRow = this.people_list.querySelector('.form__row:last-child')
    const min = this.input.getAttribute('min')
    const value = parseInt(this.input.value)

    if(value <= min) {
      this.btn_remove.classList.add('disabled')
    } else {
      this.btn.classList.remove('disabled')
      this.input.value = value - 1

      if(value > 2){
        lastRow.remove()
      }
    }

    this.changeHandler()
  }

  clickHandler = () => {
    let clone = this.people_row.cloneNode(true)
    const max = this.input.getAttribute('max')
    const value = parseInt(this.input.value)

    if(value >= max) {
      this.btn.classList.add('disabled')
    } else {
      this.btn_remove.classList.remove('disabled')
      this.input.value = value + 1

      if(value > 1) {
        this.people_list.insertAdjacentElement('beforeend', clone)
      }
    }

    this.changeHandler()
  }
}

new ReservationPersons()
